/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_IntimatesInputs */

const en_val_intimates = /** @type {(inputs: Val_IntimatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intimates`)
};

const es_val_intimates = /** @type {(inputs: Val_IntimatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ropa íntima`)
};

const fr_val_intimates = /** @type {(inputs: Val_IntimatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-vêtements`)
};

const de_val_intimates = /** @type {(inputs: Val_IntimatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterwäsche`)
};

const ja_val_intimates = /** @type {(inputs: Val_IntimatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インナー・下着`)
};

const zh_val_intimates = /** @type {(inputs: Val_IntimatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内衣`)
};

const ar_val_intimates = /** @type {(inputs: Val_IntimatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملابس داخلية`)
};

const id_val_intimates = /** @type {(inputs: Val_IntimatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakaian Dalam`)
};

const it_val_intimates = /** @type {(inputs: Val_IntimatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intimo`)
};

const ru_val_intimates = /** @type {(inputs: Val_IntimatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нижнее белье`)
};

const pt_val_intimates = /** @type {(inputs: Val_IntimatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moda Íntima`)
};

const ko_val_intimates = /** @type {(inputs: Val_IntimatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`언더웨어`)
};

/**
* | output |
* | --- |
* | "Intimates" |
*
* @param {Val_IntimatesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_intimates = /** @type {((inputs?: Val_IntimatesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_IntimatesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_intimates(inputs)
	if (locale === "es") return es_val_intimates(inputs)
	if (locale === "fr") return fr_val_intimates(inputs)
	if (locale === "de") return de_val_intimates(inputs)
	if (locale === "ja") return ja_val_intimates(inputs)
	if (locale === "zh") return zh_val_intimates(inputs)
	if (locale === "ar") return ar_val_intimates(inputs)
	if (locale === "id") return id_val_intimates(inputs)
	if (locale === "it") return it_val_intimates(inputs)
	if (locale === "ru") return ru_val_intimates(inputs)
	if (locale === "pt") return pt_val_intimates(inputs)
	return ko_val_intimates(inputs)
});